import { useEffect, useRef, useState } from "react";
import phonesDB from "./phonesdb";
import s from "./Phone.module.scss";

function PhonesDropdown() {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  // закрытие по клику вне
  useEffect(() => {
    const onDocClick = (e) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(e.target)) setOpen(false);
    };

    const onEsc = (e) => {
      if (e.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onEsc);

    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  if (!phonesDB?.main) return null;

  return (
    <div ref={wrapRef} className={s.wrapper}>
      {/* верхняя строка: основной номер + стрелка */}
      <div className={s.mainRow}>
        <a href={phonesDB.main.href} className={s.mainLink}>
          {phonesDB.main.value}
        </a>

        {phonesDB.additional?.length > 0 && (
          <button
            type="button"
            className={s.arrowBtn}
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-label={open ? "Свернуть телефоны" : "Показать телефоны"}
          >
            <span>еще</span>
            <span className={open ? s.arrowUp : s.arrowDown} />
          </button>
        )}
      </div>

      {/* выпадающий список */}
      {open && phonesDB.additional?.length > 0 && (
        <div className={s.list}>
          {phonesDB.additional.map((p, i) => (
            <a
              key={`${p.href}-${i}`}
              href={p.href}
              className={s.item}
              onClick={() => setOpen(false)} // закроем после выбора
            >
              <span className={s.value}>{p.value}</span>
              <span className={s.label}>{p.label}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

export default PhonesDropdown;
